const getCode = state => state.storeView.code;
const getLocale = state => state.storeView.locale;
const getMessages = state => state.storeView.messages;

export default {
  getCode,
  getLocale,
  getMessages
};
